exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5 {\n  border-radius: 3px;\n  color: #fff;\n  background: #565656;\n  padding-left: 4px;\n  padding-right: 4px;\n  display: inline-block;\n  margin-bottom: 6px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/site-setup/cat-setup/components/wiz-eod-cat/wiz-eod-cat.component.scss
// module id = ../../../../../src/app/views/site-admin/site-setup/cat-setup/components/wiz-eod-cat/wiz-eod-cat.component.scss
// module chunks = main